export default __webpack_public_path__ + "static/media/success_noti.466554b1.svg";